module.exports = __webpack_public_path__ + "img/interpackmaxi_dg.0be425e9.png";